import React from 'react';
import { DataEntryGrid } from '../DataEntryGrid';
import { EeLoadingArea } from 'pages/Scenarios/components/EeLoadingArea';

export const DataEntryTableGroup = ({
  groupRows,
  columns,
  editable,
  kpiGroup,
  onGridRowEdit,
  isLoading = false,
  scrolledOnceGrid,
  onScrolledOnce,
  showLastPeriod = true
}: {
  groupRows: any;
  columns: any;
  editable: boolean;
  kpiGroup: any;
  onGridRowEdit: any;
  isLoading: boolean;
  scrolledOnceGrid: any;
  onScrolledOnce: () => void;
  showLastPeriod?: boolean;
}) => {
  return (
    <div className="mb-4" key={kpiGroup.name}>
      <h3 className="pb-2">{kpiGroup.name}</h3>
      <div className="position-relative">
        {isLoading && (
          <EeLoadingArea
            style={{
              backgroundColor: '#ffffffb3',
            }}
            position="absolute"
          />
        )}
        <DataEntryGrid
          columns={columns}
          data={groupRows}
          editable={editable}
          onRowsChange={(
            { rowId, column, value }: { rowId: string; column: string; value: string },
          ) => {
            onGridRowEdit(kpiGroup.name, { rowId, column, value });
          }}
          scrolledOnceGrid={scrolledOnceGrid}
          onScrolledOnce={onScrolledOnce}
          showLastPeriod={showLastPeriod}
        />
      </div>
    </div>
  );
};
